<div *ngIf="src && nonMobile()" class="row hero-img d-none d-md-flex">
    <div class="col">
        <img #heroImage [src]="src" alt="altName" class="img-fluid" [class.nestled]="nestled" />
    </div>
</div>